<template>
    <ul :class="[className, 'submenu']">
        <slot name="firstItem" />
        <li
            v-for="(item, x) in items"
            :key="x"
        >
            <slot :data="{ item, x }" name="item" />
        </li>
        <slot name="lastItem" />
    </ul>
</template>

<script>
export default {

    props: {
        className: {
            default: ''
        },
        items: {
            type: Array,
            required: true
        },
    },
    data: () => ({
        submenuActive: false,
    }),
    methods: {

    },
}
</script>